import React from 'react';
import { ArrowRightIcon, ShieldIcon, LeafIcon, HeartIcon, ShoppingBasket, Building2, Stethoscope } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
function FeatureItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-2" data-id="element-335" data-mp="2h3piw9ts8zyb">
      <span style={{
      color: '#7DC920',
      fontWeight: 700
    }} data-id="element-336" data-mp="2lzwsqdpauvlj">
        ✓
      </span>
      <span data-id="element-337" data-mp="27b0dnwotsibf">{text}</span>
    </li>;
}
const impactItems = [{
  icon: ShoppingBasket,
  title: 'Alimentos',
  text: 'Canastas de comida para familias desplazadas'
}, {
  icon: Building2,
  title: 'Refugio',
  text: 'Albergue temporal seguro'
}, {
  icon: Stethoscope,
  title: 'Atención Médica',
  text: 'Medicamentos y primeros auxilios'
}];
export function DonarVenezuela() {
  useDocumentMeta({
    title: 'Dona para Venezuela | Pancita Feliz Foundation',
    description: 'Dona directamente para las familias venezolanas afectadas por los terremotos de junio 2026.',
    path: '/donar-venezuela'
  });
  return <main className="w-full" data-id="element-338" data-mp="1m0cwbmmprneg">
      {/* Hero */}
      <section className="text-center" style={{
      background: 'linear-gradient(135deg, #1a3a0a 0%, #2d5a1b 100%)',
      padding: '80px 20px 60px',
      color: 'white'
    }} data-id="element-339" data-mp="1lzl5ep42adui">
        <img src="https://cdn.magicpatterns.com/uploads/wpdp43pGEjSRNDR3FLVv4Q/pancita_feliz.png" alt="Pancita Feliz Foundation" className="mp-donar-hero-logo" style={{
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto 32px auto',
        filter: 'brightness(0) invert(1)'
      }} data-id="element-340" data-mp="1uyydbdcjeud4" />
        <p style={{
        fontSize: '13px',
        color: '#a8e063',
        letterSpacing: '3px',
        fontWeight: 600,
        textTransform: 'uppercase',
        marginBottom: '12px'
      }} data-id="element-341" data-mp="okpckhd767wa">
          Emergencia Activa
        </p>
        <h1 className="mp-donar-title" style={{
        fontWeight: 700,
        color: 'white',
        marginBottom: '16px'
      }} data-id="element-342" data-mp="2jm14rtj1bie9">
          Dona para la Emergencia en Venezuela
        </h1>
        <p style={{
        fontSize: '18px',
        color: 'rgba(255,255,255,0.85)',
        maxWidth: '580px',
        margin: '0 auto 40px'
      }} data-id="element-343" data-mp="2yd1ee1vipibz">
          Tu donación llega directamente a las familias venezolanas más
          afectadas por los terremotos.
        </p>
      </section>

      {/* Donation cards */}
      <section className="mp-donar-body" style={{
      background: '#f8faf5',
      padding: '60px 20px'
    }} data-id="element-344" data-mp="2eosltqq2baby">
        <div className="mp-donar-cards" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px',
        maxWidth: '700px',
        margin: '0 auto'
      }} data-id="element-345" data-mp="3m1kkcar3hj0w">
          {/* Card 1: Stripe */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #635BFF',
          textAlign: 'center'
        }} data-id="element-346" data-mp="1aeqx522g5nm6">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #635BFF 0%, #8B7FFF 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(99,91,255,0.35)'
          }} data-id="element-347" data-mp="vr5vlcl7zwgd">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" alt="Stripe" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-348" data-mp="2c3t96cixikam" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-349" data-mp="14rli9unvaiwy">
              Donar con Tarjeta
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-350" data-mp="uuyw92jt1ltc">
              Visa, Mastercard, American Express
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-351" data-mp="74d12buwfw0r">
              <FeatureItem text="Pago 100% seguro" data-id="element-352" data-mp="3onjy26lmc9to" />
              <FeatureItem text="Procesado por Stripe" data-id="element-353" data-mp="3jnxk1uxyupjt" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-354" data-mp="3jp8qk2isqbem" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-355" data-mp="2fu3grmgeoz8" />
            </ul>
            <a href="https://buy.stripe.com/fZu9ATfyrgrVc9JefU00001" target="_blank" rel="noopener noreferrer" className="mp-stripe-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#635BFF',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-356" data-mp="3tlva8nzdywf2">
              💳 Donar con Tarjeta
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-357" data-mp="q3bo837awmsp" />
            </a>
          </div>

          {/* Card 2: PayPal */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #009cde',
          textAlign: 'center'
        }} data-id="element-358" data-mp="126wikl36mx4d">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #009cde 0%, #003087 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(0,156,222,0.35)'
          }} data-id="element-359" data-mp="1fzm46oesu00y">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-360" data-mp="i2in0b011q2" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-361" data-mp="250a4mj7lmkkk">
              Donar con PayPal
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-362" data-mp="2spcu2d8h5hpm">
              Saldo PayPal o tarjeta vinculada
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-363" data-mp="2ir6rruira9k8">
              <FeatureItem text="Pago 100% seguro" data-id="element-364" data-mp="37esq8wdd81km" />
              <FeatureItem text="Procesado por PayPal" data-id="element-365" data-mp="37d7w37uyqkna" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-366" data-mp="3ce5ftovmfmqw" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-367" data-mp="3cb9fxv07qnzt" />
            </ul>
            <a href="https://www.paypal.com/ncp/payment/DWMUXE35XUQ4N" target="_blank" rel="noopener noreferrer" className="mp-paypal-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#009cde',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-368" data-mp="2xhwjow711pip">
              🅿 Donar con PayPal
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-369" data-mp="hpz6i4wrt47e" />
            </a>
          </div>
        </div>

        {/* Red urgency banner */}
        <div style={{
        background: '#ffeeee',
        border: '1px solid #ffcccc',
        borderRadius: '12px',
        padding: '16px 24px',
        maxWidth: '700px',
        margin: '24px auto 0',
        textAlign: 'center',
        fontSize: '14px',
        color: '#CC0000',
        fontWeight: 600
      }} data-id="element-370" data-mp="1xgj9hawndc9r">
          🚨 100% de tu donación va directo a familias venezolanas afectadas por
          el terremoto
        </div>

        {/* Trust section */}
        <div style={{
        marginTop: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        flexWrap: 'wrap'
      }} data-id="element-371" data-mp="1shopi5my1ho2">
          {[{
          icon: ShieldIcon,
          label: 'Pagos 100% seguros'
        }, {
          icon: LeafIcon,
          label: 'Fundación registrada'
        }, {
          icon: HeartIcon,
          label: 'Tu donación hace la diferencia'
        }].map(({
          icon: Icon,
          label
        }) => <span key={label} style={{
          fontSize: '13px',
          color: '#555',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }} data-id="element-372" data-mp="35pxx9lid1d4a">
              <Icon size={16} color="#7DC920" data-id="element-373" data-mp="2qsopjh8r1wqe" />
              {label}
            </span>)}
        </div>

        {/* Impact section */}
        <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '700px',
        margin: '40px auto 0',
        padding: '32px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
      }} data-id="element-374" data-mp="2htju4jshijig">
          <h3 style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1a1a1a',
          textAlign: 'center',
          marginBottom: '24px'
        }} data-id="element-375" data-mp="g040de13ooj9">
            ¿A dónde va tu donación para Venezuela?
          </h3>
          <div className="mp-donar-impact" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
          textAlign: 'center'
        }} data-id="element-376" data-mp="xcau7iy5sm9k">
            {impactItems.map(({
            icon: Icon,
            title,
            text
          }) => <div key={title} className="flex flex-col items-center" data-id="element-377" data-mp="9nrn36quifj2">
                <Icon size={32} color="#7DC920" data-id="element-378" data-mp="ejghywrx7891" />
                <p style={{
              fontSize: '15px',
              fontWeight: 600,
              color: '#1a1a1a',
              margin: '8px 0 4px'
            }} data-id="element-379" data-mp="imd06mdjt2cg">
                  {title}
                </p>
                <p style={{
              fontSize: '13px',
              color: '#666'
            }} data-id="element-380" data-mp="3r2e9qkxwb25v">
                  {text}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </main>;
}